import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';

export default class ModalSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entrada: props.entrada,
            saida: props.saida,
            tipo: props.tipo,
            data: [
                {hora: '00:00'},
                {hora: '00:15'},
                {hora: '00:30'},
                {hora: '00:45'},
                {hora: '01:00'},
                {hora: '01:15'},
                {hora: '01:30'},
                {hora: '01:45'},
                {hora: '02:00'},
                {hora: '02:15'},
                {hora: '02:30'},
                {hora: '02:45'},
                {hora: '03:00'},
                {hora: '03:15'},
                {hora: '03:30'},
                {hora: '03:45'},
                {hora: '04:00'},
                {hora: '04:15'},
                {hora: '04:30'},
                {hora: '04:45'},
                {hora: '05:00'},
                {hora: '05:15'},
                {hora: '05:30'},
                {hora: '05:45'},
                {hora: '06:00'},
                {hora: '06:15'},
                {hora: '06:30'},
                {hora: '06:45'},
                {hora: '07:00'},
                {hora: '07:15'},
                {hora: '07:30'},
                {hora: '07:45'},
                {hora: '08:00'},
                {hora: '08:15'},
                {hora: '08:30'},
                {hora: '08:45'},
                {hora: '09:00'},
                {hora: '09:15'},
                {hora: '09:30'},
                {hora: '09:45'},
                {hora: '10:00'},
                {hora: '10:15'},
                {hora: '10:30'},
                {hora: '10:45'},
                {hora: '11:00'},
                {hora: '11:15'},
                {hora: '11:30'},
                {hora: '11:45'},
                {hora: '12:00'},
                {hora: '12:15'},
                {hora: '12:30'},
                {hora: '12:45'},
                {hora: '13:00'},
                {hora: '13:15'},
                {hora: '13:30'},
                {hora: '13:45'},
                {hora: '14:00'},
                {hora: '14:15'},
                {hora: '14:30'},
                {hora: '14:45'},
                {hora: '15:00'},
                {hora: '15:15'},
                {hora: '15:30'},
                {hora: '15:45'},
                {hora: '16:00'},
                {hora: '16:15'},
                {hora: '16:30'},
                {hora: '16:45'},
                {hora: '17:00'},
                {hora: '17:15'},
                {hora: '17:30'},
                {hora: '17:45'},
                {hora: '18:00'},
                {hora: '18:15'},
                {hora: '18:30'},
                {hora: '18:45'},
                {hora: '19:00'},
                {hora: '19:15'},
                {hora: '19:30'},
                {hora: '19:45'},
                {hora: '20:00'},
                {hora: '20:15'},
                {hora: '20:30'},
                {hora: '20:45'},
                {hora: '21:00'},
                {hora: '21:15'},
                {hora: '21:30'},
                {hora: '21:45'},
                {hora: '22:00'},
                {hora: '22:15'},
                {hora: '22:30'},
                {hora: '22:45'},
                {hora: '23:00'},
                {hora: '23:15'},
                {hora: '23:30'},
                {hora: '23:45'},
                {hora: '23:59'},
            ]
        }
    }

    // componentDidMount() {
    //     var str1 = "00:45",
    //     str2 = "00:30";

    //     if (str1 <= str2)
    //         alert("menor ou igual");
    //     else
    //         alert("Time 2 is later than time 1");
    // }

    checkAvailable(hora) {
        switch (this.state.tipo) {
            case 'entrada':
                if (this.state.saida !== 'Selecione') {
                    if (hora >= this.state.saida) {
                        return false;
                    }
                }
                return true;
            case 'saida':
                if (this.state.entrada !== 'Selecione') {
                    if (hora <= this.state.entrada) {
                        return false;
                    }
                }
                return true;
            default:
                return true;
        }
    }

    render() {
        return (
            <Container>
                <div className="default">
                    <div className="close">
                        <button 
                            onClick={() => this.props.closeModal()}>
                            <IoMdClose color="#fff" className="i-close" />
                        </button>
                    </div>
                    <label>
                        Selecione um horário
                    </label>
                </div>
                { this.state.data.map(item => (
                    <div
                        onClick={() => this.checkAvailable(item.hora) ? this.props.selecionar(this.state.tipo, item.hora) : null}
                        className={this.checkAvailable(item.hora) ? 'horario-disponivel' : 'horario-indisponivel'}>
                        <label className="disponivel">
                            {item.hora}
                        </label>
                    </div>
                )) }
            </Container>
        )
    }
}